// Plantilles base predefinides per AEH Reus
// Cada tipus de negoci té els seus equips, tasques i documents habituals

export const BUSINESS_TYPES = {
  restaurant:     { label: "Restaurant",               emoji: "🍽️" },
  bar:            { label: "Bar",                       emoji: "🍺" },
  cafeteria:      { label: "Cafeteria",                 emoji: "☕" },
  takeaway:       { label: "Take Away",                 emoji: "🥡" },
  rostisseria:    { label: "Rostisseria",               emoji: "🍗" },
  hotel_cuina:    { label: "Hotel amb Cuina",           emoji: "🏨" },
  pastisseria:    { label: "Pastisseria / Forn",        emoji: "🥐" },
};

export const DEFAULT_TEMPLATES = {
  restaurant: {
    temperature_equipment: [
      { name: "Nevera cuina 1", equipment_type: "fridge", min_limit: 0, max_limit: 5 },
      { name: "Nevera cuina 2", equipment_type: "fridge", min_limit: 0, max_limit: 5 },
      { name: "Congelador 1",   equipment_type: "freezer", min_limit: -25, max_limit: -18 },
      { name: "Cambra freda",   equipment_type: "chamber", min_limit: 0, max_limit: 4 },
      { name: "Freidora (oli)", equipment_type: "fryer_oil", min_limit: 0, max_limit: 180 },
      { name: "Recepció mercaderies fredes", equipment_type: "cold_reception", min_limit: 0, max_limit: 8 },
    ],
    cleaning_tasks: [
      { zone: "kitchen", task: "Neteja superfícies de treball", frequency: "daily" },
      { zone: "kitchen", task: "Neteja fogons i plaques", frequency: "daily" },
      { zone: "kitchen", task: "Neteja freidores", frequency: "daily" },
      { zone: "kitchen", task: "Neteja filtres campana extractora", frequency: "weekly" },
      { zone: "kitchen", task: "Neteja forn", frequency: "weekly" },
      { zone: "bar", task: "Neteja màquina de cafè", frequency: "daily" },
      { zone: "bar", task: "Neteja mostradors i barres", frequency: "daily" },
      { zone: "dining", task: "Neteja taules i cadires", frequency: "daily" },
      { zone: "dining", task: "Neteja terres menjador", frequency: "daily" },
      { zone: "bathrooms", task: "Neteja i desinfecció lavabos", frequency: "daily" },
      { zone: "storage", task: "Neteja magatzem sec", frequency: "weekly" },
      { zone: "chambers", task: "Neteja cambres fredes", frequency: "weekly" },
      { zone: "machinery", task: "Neteja lavavajillas", frequency: "daily" },
    ],
    document_categories: ["license", "certificate", "haccp", "protocol", "training", "insurance", "supplier"],
    incident_categories: ["food_safety", "equipment_failure", "temperature_deviation", "cleaning_issue", "supplier_issue", "staff_issue"],
  },

  bar: {
    temperature_equipment: [
      { name: "Nevera de servei 1", equipment_type: "fridge", min_limit: 2, max_limit: 6 },
      { name: "Nevera de servei 2", equipment_type: "fridge", min_limit: 2, max_limit: 6 },
      { name: "Vitrina refrigerada", equipment_type: "fridge", min_limit: 2, max_limit: 8 },
      { name: "Congelador",         equipment_type: "freezer", min_limit: -25, max_limit: -18 },
    ],
    cleaning_tasks: [
      { zone: "bar", task: "Neteja màquina de cafè", frequency: "daily" },
      { zone: "bar", task: "Neteja barres i mostradors", frequency: "daily" },
      { zone: "bar", task: "Neteja neveres", frequency: "daily" },
      { zone: "bar", task: "Neteja i descalcificació màquines", frequency: "weekly" },
      { zone: "dining", task: "Neteja taules i cadires", frequency: "daily" },
      { zone: "dining", task: "Neteja terres", frequency: "daily" },
      { zone: "bathrooms", task: "Neteja lavabos", frequency: "daily" },
    ],
    document_categories: ["license", "certificate", "training", "insurance"],
    incident_categories: ["equipment_failure", "cleaning_issue", "staff_issue", "other"],
  },

  cafeteria: {
    temperature_equipment: [
      { name: "Vitrina de pastisseria", equipment_type: "fridge", min_limit: 2, max_limit: 8 },
      { name: "Nevera de servei",       equipment_type: "fridge", min_limit: 2, max_limit: 6 },
      { name: "Congelador gelats",      equipment_type: "freezer", min_limit: -25, max_limit: -18 },
    ],
    cleaning_tasks: [
      { zone: "bar", task: "Neteja màquina de cafè", frequency: "daily" },
      { zone: "bar", task: "Neteja vitrina i expositors", frequency: "daily" },
      { zone: "kitchen", task: "Neteja zona de preparació", frequency: "daily" },
      { zone: "dining", task: "Neteja taules", frequency: "daily" },
      { zone: "bathrooms", task: "Neteja lavabos", frequency: "daily" },
    ],
    document_categories: ["license", "certificate", "haccp", "training", "insurance"],
    incident_categories: ["food_safety", "equipment_failure", "cleaning_issue", "staff_issue"],
  },

  takeaway: {
    temperature_equipment: [
      { name: "Nevera productes preparats", equipment_type: "prepared_food", min_limit: 0, max_limit: 4 },
      { name: "Congelador",                 equipment_type: "freezer", min_limit: -25, max_limit: -18 },
      { name: "Recepció matèries primeres", equipment_type: "cold_reception", min_limit: 0, max_limit: 8 },
    ],
    cleaning_tasks: [
      { zone: "kitchen", task: "Neteja zona de preparació", frequency: "daily" },
      { zone: "kitchen", task: "Neteja planxes i freidores", frequency: "daily" },
      { zone: "bar", task: "Neteja mostrador de servei", frequency: "daily" },
      { zone: "storage", task: "Neteja magatzem", frequency: "weekly" },
      { zone: "bathrooms", task: "Neteja lavabos", frequency: "daily" },
    ],
    document_categories: ["license", "certificate", "haccp", "protocol", "training"],
    incident_categories: ["food_safety", "equipment_failure", "temperature_deviation", "supplier_issue"],
  },

  rostisseria: {
    temperature_equipment: [
      { name: "Vitrina calent exposició",   equipment_type: "prepared_food", min_limit: 65, max_limit: 100 },
      { name: "Nevera productes crus",      equipment_type: "fridge", min_limit: 0, max_limit: 4 },
      { name: "Congelador",                 equipment_type: "freezer", min_limit: -25, max_limit: -18 },
      { name: "Recepció aus i carns",       equipment_type: "cold_reception", min_limit: 0, max_limit: 6 },
    ],
    cleaning_tasks: [
      { zone: "kitchen", task: "Neteja forns rostidors", frequency: "daily" },
      { zone: "kitchen", task: "Neteja safates i graelles", frequency: "daily" },
      { zone: "bar", task: "Neteja vitrina exposició calent", frequency: "daily" },
      { zone: "bar", task: "Neteja mostrador", frequency: "daily" },
      { zone: "storage", task: "Neteja càmera freda", frequency: "weekly" },
    ],
    document_categories: ["license", "certificate", "haccp", "protocol", "training", "supplier"],
    incident_categories: ["food_safety", "temperature_deviation", "equipment_failure", "supplier_issue"],
  },

  hotel_cuina: {
    temperature_equipment: [
      { name: "Cambra freda carn",    equipment_type: "chamber", min_limit: 0, max_limit: 4 },
      { name: "Cambra freda peix",    equipment_type: "chamber", min_limit: 0, max_limit: 2 },
      { name: "Cambra freda lactis",  equipment_type: "chamber", min_limit: 2, max_limit: 6 },
      { name: "Cambra congelats",     equipment_type: "freezer", min_limit: -25, max_limit: -18 },
      { name: "Nevera cuina 1",       equipment_type: "fridge", min_limit: 0, max_limit: 5 },
      { name: "Nevera cuina 2",       equipment_type: "fridge", min_limit: 0, max_limit: 5 },
      { name: "Bany maria buffet",    equipment_type: "prepared_food", min_limit: 65, max_limit: 100 },
      { name: "Recepció mercaderies", equipment_type: "cold_reception", min_limit: 0, max_limit: 8 },
    ],
    cleaning_tasks: [
      { zone: "kitchen", task: "Neteja cuina professional", frequency: "daily" },
      { zone: "kitchen", task: "Neteja campana extractora", frequency: "weekly" },
      { zone: "kitchen", task: "Neteja fogons i forn", frequency: "daily" },
      { zone: "chambers", task: "Neteja cambres fredes", frequency: "weekly" },
      { zone: "dining", task: "Neteja sala de restauració", frequency: "daily" },
      { zone: "bar", task: "Neteja zona buffet", frequency: "daily" },
      { zone: "bathrooms", task: "Neteja lavabos públics", frequency: "daily" },
      { zone: "storage", task: "Neteja magatzem", frequency: "weekly" },
    ],
    document_categories: ["license", "certificate", "haccp", "protocol", "training", "insurance", "supplier", "other"],
    incident_categories: ["food_safety", "equipment_failure", "temperature_deviation", "cleaning_issue", "supplier_issue", "staff_issue"],
  },

  pastisseria: {
    temperature_equipment: [
      { name: "Vitrina refrigerada",    equipment_type: "fridge", min_limit: 2, max_limit: 8 },
      { name: "Cambra repòs masses",    equipment_type: "fridge", min_limit: 2, max_limit: 6 },
      { name: "Congelador producció",   equipment_type: "freezer", min_limit: -25, max_limit: -18 },
      { name: "Nevera matèries primeres", equipment_type: "fridge", min_limit: 0, max_limit: 5 },
    ],
    cleaning_tasks: [
      { zone: "kitchen", task: "Neteja taules de pastisseria", frequency: "daily" },
      { zone: "kitchen", task: "Neteja batedores i estris", frequency: "daily" },
      { zone: "kitchen", task: "Neteja forns", frequency: "daily" },
      { zone: "kitchen", task: "Neteja superfícies treball", frequency: "daily" },
      { zone: "bar", task: "Neteja vitrina exposició", frequency: "daily" },
      { zone: "bar", task: "Neteja mostrador", frequency: "daily" },
      { zone: "storage", task: "Neteja magatzem ingredients", frequency: "weekly" },
      { zone: "bathrooms", task: "Neteja lavabos", frequency: "daily" },
    ],
    document_categories: ["license", "certificate", "haccp", "protocol", "training", "insurance"],
    incident_categories: ["food_safety", "equipment_failure", "cleaning_issue", "supplier_issue"],
  },
};

export const ZONE_LABELS = {
  kitchen: "Cuina",
  bar: "Barra / Mostrador",
  dining: "Sala / Menjador",
  bathrooms: "Lavabos",
  storage: "Magatzem",
  chambers: "Cambres",
  machinery: "Maquinària",
  terrace: "Terrassa",
};

export const EQUIPMENT_TYPE_LABELS = {
  fridge: "Nevera",
  freezer: "Congelador",
  chamber: "Cambra freda",
  prepared_food: "Aliments cuinats",
  fryer_oil: "Oli fregidor",
  cold_reception: "Recepció en fred",
};

export const FREQUENCY_LABELS = {
  daily: "Diària",
  weekly: "Setmanal",
  monthly: "Mensual",
};